import { Injectable } from "@angular/core"
import { BehaviorSubject } from "rxjs"
import { PortingData } from "../meta/PortingData.interface"
import { INITIAL_PORTING_DATA } from "../meta/initial-porting-data.const"

@Injectable({
  providedIn: "root"
})
export class PortingService {
  private readonly _portingData$ = new BehaviorSubject<PortingData>(INITIAL_PORTING_DATA)
  public readonly portingData$ = this._portingData$.asObservable()

  public getPortingData(): PortingData {
    return this._portingData$.getValue()
  }

  public setPortingData(portingData: Partial<PortingData>): void {
    this._portingData$.next({
      ...this._portingData$.getValue(),
      ...portingData
    })
  }

  public getNumber(index: number): string {
    const numbers = this._portingData$.getValue().numbers
    if (numbers.length > index) {
      return numbers[index - 1]
    }
    return ""
  }

  public setNumber(index: number, number: string): void {
    const numbers = [...this._portingData$.getValue().numbers]
    numbers.splice(index - 1, 1, number)
    this.setPortingData({
      numbers
    })
  }
}
